import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';

const routes: Routes = [
  { path: 'auth-callback', component: AuthCallbackComponent },

  {
    path: 'partner',
    loadChildren: () => import('./partner/partner.module').then((m) => m.PartnerModule)
  },
  {
    path: 'lead',
    loadChildren: () => import('./lead/lead.module').then((m) => m.LeadModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('./orders/orders.module').then((m) => m.OrdersModule)
  },
  {
    path: 'usuarios',
    loadChildren: () => import('./usuarios/usuarios.module').then((m) => m.UsuariosModule)
  },
  {
    path: 'partner-user',
    loadChildren: () => import('./partner-user/partner-user.module').then((m) => m.PartnerUserModule)
  },
  {
    path: 'menu',
    loadChildren: () => import('./menuedit/menuedit.module').then((m) => m.MenuModule)
  },
  {
    path: 'liquidacion',
    loadChildren: () => import('./liquidacion/liquidacion.module').then((m) => m.LiquidacionModule)
  },
  {
    path: 'product',
    loadChildren: () => import('./producto/product.module').then((m) => m.ProductModule)
  },
  {
    path: 'promos',
    loadChildren: () => import('./promos/promos.module').then((m) => m.PromosModule)
  },
  {
    path: 'contract-template',
    loadChildren: () => import('./contract-template/contract-template.module').then((m) => m.ContractTemplateModule)
  },
  {
    path: 'orders-occident',
    loadChildren: () => import('./orders-occident/order-occident.module').then((m) => m.OrdersOccidentModule)
  },
  {
    path: 'order-atlas',
    loadChildren: () => import('./orderatlas/order-atlas.module').then((m) => m.OrderAtlasModule)
  },

  { path: '**', redirectTo: '', pathMatch: 'full' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
